function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import _ from 'lodash';
import { MARKETING_CAMPAIGN_PARAMS } from 'shared/constants';
export function getMarketingParams(router, persistedSessionData) {
    var _router_query;
    var fromQuery = _.pick((_router_query = router === null || router === void 0 ? void 0 : router.query) !== null && _router_query !== void 0 ? _router_query : {}, MARKETING_CAMPAIGN_PARAMS);
    if (!_.isEmpty(fromQuery)) {
        return fromQuery;
    }
    var fromSession = _.get(persistedSessionData, 'parameters', {});
    return _.pick(fromSession, MARKETING_CAMPAIGN_PARAMS);
}
/**
 * Appends the current marketing params to a URL string so they survive navigations
 * that build the URL from scratch. Params already present on the URL win.
 */ export function appendMarketingParams(url, router, persistedSessionData) {
    if (!_.isString(url) || url.length === 0) {
        return url;
    }
    var marketingParams = getMarketingParams(router, persistedSessionData);
    if (_.isEmpty(marketingParams)) {
        return url;
    }
    var _url_split = _sliced_to_array(url.split('#'), 2), urlWithoutHash = _url_split[0], tmp = _url_split[1], hash = tmp === void 0 ? '' : tmp;
    var _urlWithoutHash_split = _sliced_to_array(urlWithoutHash.split('?'), 2), path = _urlWithoutHash_split[0], tmp1 = _urlWithoutHash_split[1], existingQuery = tmp1 === void 0 ? '' : tmp1;
    var searchParams = new URLSearchParams(existingQuery);
    Object.entries(marketingParams).forEach(function(param) {
        var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
        if (!searchParams.has(key)) {
            searchParams.set(key, Array.isArray(value) ? value[0] : value);
        }
    });
    var queryString = searchParams.toString();
    var hashSuffix = hash ? "#".concat(hash) : '';
    return queryString ? "".concat(path, "?").concat(queryString).concat(hashSuffix) : "".concat(path).concat(hashSuffix);
}
